import { FilterFields } from "src/firebase/firestore/types";
import { languageTuples } from "src/utils/util";
import { FilterPostsInputs } from "../types/index.type";
import { Post } from "../types/post.type";

export const buildPostQuery = (where: FilterPostsInputs): FilterFields<Post> => {
  const filter: FilterFields<Post> = {};
  if (where.id) filter.id = where.id;

  if (where.userRole) {
    filter.role = where.userRole;
  }

  if (where.type) {
    filter.type = where.type;
  }

  if (where.visibility) {
    filter.visibility = where.visibility;
  }

  if (where.userId) {
    filter.userId = where.userId;
  }

  if (where.langCodes && where.langCodes.length > 0) {
    filter.langCodes = { $arrayContainsAny: where.langCodes };
  }

  return filter;
};

export const postsLanguagesOptions = [["ALL", "All Spaces"], ...languageTuples];
